import { render, staticRenderFns } from "./EnvRanking.html.vue?vue&type=template&id=52a1317e"
import script from "./EnvRanking.html.vue?vue&type=script&lang=js"
export * from "./EnvRanking.html.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/envRanking/index.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "~/assets/arabCSS/envRanking/index.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports